import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export const listShippers = async () => {
    const response = await axiosInterceptor.get(API.ADDRESS_BOOK.GET_SHIPPER_CONSIGNEE);

    return response;
};

export const createShipperContact = async (data: any) => {
    const response = await axiosInterceptor.post(API.SHIPPER.CONTACTS.CREATE, data);

    return response;
};

export const updateShipperContact = async (id: number, data: any) => {
    const response = await axiosInterceptor.patch(`${API.SHIPPER.CONTACTS.UPDATE}/${id}`, data);

    return response;
};

export const deleteShipperContact = async (id: number) => {
    const response = await axiosInterceptor.delete(`${API.SHIPPER.CONTACTS.DELETE}/${id}`);

    return response;
};
